import { Produktlinienname } from '@ps20/bff-models';
import { StatePreV11, StateV11 } from './11_migrate_ausgewaehlteProduktlinien.interface';

export const migrateAusgewahlteProduktlinien = (
  previousState: StatePreV11,
  newVersion: number,
): StateV11 => {
  const migratedWarenkorb = previousState.warenkorb.map(angebot => {
    return {
      ...angebot,
      ausgewaehlteLinie: (Produktlinienname as Record<string, Produktlinienname>)[angebot.ausgewaehlteLinie?.toUpperCase()],
    };
  });
  return {
    ...previousState,
    version: newVersion,
    warenkorb: migratedWarenkorb,
  } as StateV11;
};
